// UI icons imports
import IcLeft from '../assets/svgs/UiIcons/ic-left.svg';
import IcDoubleLeft from '../assets/svgs/UiIcons/ic-double-left.svg';
import IcRight from '../assets/svgs/UiIcons/ic-right.svg';
import IcDoubleRight from '../assets/svgs/UiIcons/ic-double-right.svg';
import IcDown from '../assets/svgs/UiIcons/ic-down.svg';
import IcUp from '../assets/svgs/UiIcons/ic-up.svg';
import IcPlus from '../assets/svgs/UiIcons/ic-plus.svg';
import IcClose from '../assets/svgs/UiIcons/ic-close.svg';
import IcCheck from '../assets/svgs/UiIcons/ic-check.svg';
import IcMore from '../assets/svgs/UiIcons/ic-more.svg';
import IcDownload from '../assets/svgs/UiIcons/ic-download.svg';
import IcUpload from '../assets/svgs/UiIcons/ic-upload.svg';
import IcImage from '../assets/svgs/UiIcons/ic-image.svg';
import IcGrip from '../assets/svgs/UiIcons/ic-grip.svg';
import IcMinus from '../assets/svgs/UiIcons/ic-minus.svg';
import IcCopy from '../assets/svgs/UiIcons/ic-copy.svg';
import IcCalendar from '../assets/svgs/UiIcons/ic-calendar.svg';
import IcRefresh from '../assets/svgs/UiIcons/ic-refresh.svg';
import IcCloseSquare from '../assets/svgs/UiIcons/ic-close-square.svg';
import IcCheckSquare from '../assets/svgs/UiIcons/ic-check-square.svg';
import IcExclamationSquare from '../assets/svgs/UiIcons/ic-exclamation-square.svg';
import IcExclamation from '../assets/svgs/UiIcons/ic-exclamation.svg';
import IcEye from '../assets/svgs/UiIcons/ic-eye.svg';
import IcQuestionMarkSquare from '../assets/svgs/UiIcons/ic-question-mark-square.svg';
import IcInfoSquare from '../assets/svgs/UiIcons/ic-info-square.svg';
import IcInfo from '../assets/svgs/UiIcons/ic-info.svg';
import IcDelete from '../assets/svgs/UiIcons/ic-delete.svg';
import ChecLogo from '../assets/svgs/chec-logo.svg';
import IcFacebook from '../assets/svgs/ic-fb.svg';
import IcTwitter from '../assets/svgs/ic-twitter.svg';
import IcGithub from '../assets/svgs/ic-github.svg';
import IcSlack from '../assets/svgs/ic-slack.svg';
import IcSlackColor from '../assets/svgs/ic-slack-color.svg';
import IcYouTube from '../assets/svgs/ic-youtube.svg';
import IcLink from '../assets/svgs/UiIcons/ic-link.svg';
import IcRightArrow from '../assets/svgs/UiIcons/ic-right-arrow.svg';
import IcLeftArrow from '../assets/svgs/UiIcons/ic-left-arrow.svg';
import IcUpArrow from '../assets/svgs/UiIcons/ic-up-arrow.svg';
import IcDownArrow from '../assets/svgs/UiIcons/ic-down-arrow.svg';
import IcHamburger from '../assets/svgs/UiIcons/ic-hamburger.svg';
import IcSearch from '../assets/svgs/UiIcons/ic-search.svg';
import IcThumbsUp from '../assets/svgs/UiIcons/ic-thumbs-up.svg';
import IcThumbsDown from '../assets/svgs/UiIcons/ic-thumbs-down.svg';
import IcTrash from '../assets/svgs/UiIcons/ic-trash.svg';
import IcDrag from '../assets/svgs/UiIcons/ic-drag.svg';
import IcBold from '../assets/svgs/UiIcons/ic-bold.svg';
import IcItalic from '../assets/svgs/UiIcons/ic-italic.svg';
import IcBulletList from '../assets/svgs/UiIcons/ic-bullet-list.svg';
import IcQuote from '../assets/svgs/UiIcons/ic-quote.svg';

// Nav icons imports
import IcHome from '../assets/svgs/NavIcons/ic-home.svg';
import IcOrders from '../assets/svgs/NavIcons/ic-orders.svg';
import IcProducts from '../assets/svgs/NavIcons/ic-products.svg';
import IcDiscounts from '../assets/svgs/NavIcons/ic-discounts.svg';
import IcDevelopers from '../assets/svgs/NavIcons/ic-developers.svg';
import IcLogs from '../assets/svgs/NavIcons/ic-logs.svg';
import IcSettings from '../assets/svgs/NavIcons/ic-settings.svg';
import IcCategories from '../assets/svgs/NavIcons/ic-categories.svg';
import IcIntegrations from '../assets/svgs/NavIcons/ic-integrations.svg';
import IcSpaces from '../assets/svgs/NavIcons/ic-spaces.svg';
import IcStar from '../assets/svgs/NavIcons/ic-star.svg';
import IcRays from '../assets/svgs/NavIcons/ic-rays.svg';
import IcCustomers from '../assets/svgs/NavIcons/ic-customers.svg';
import IcAccount from '../assets/svgs/NavIcons/ic-account.svg';

// Marketing icons imports
import IcStandard from '../assets/svgs/MIcons/ic-standard.svg';
import IcPlusPlan from '../assets/svgs/MIcons/ic-plus-plan.svg';
import IcPro from '../assets/svgs/MIcons/ic-pro.svg';
import IcRise from '../assets/svgs/MIcons/ic-rise.svg';
import IcGrowth from '../assets/svgs/MIcons/ic-growth.svg';
import IcEnterprise from '../assets/svgs/MIcons/ic-enterprise.svg';
import IcCodeGray from '../assets/svgs/MIcons/ic-code-gray.svg';
import IcControls from '../assets/svgs/MIcons/ic-controls.svg';
import IcColorStart from '../assets/svgs/MIcons/ic-start.svg';
import IcColorCart from '../assets/svgs/MIcons/ic-cart.svg';
import IcColorCheckout from '../assets/svgs/MIcons/ic-checkout.svg';
import IcColorOrders from '../assets/svgs/MIcons/ic-orders.svg';
import IcColorProducts from '../assets/svgs/MIcons/ic-products.svg';
import IcColorCategories from '../assets/svgs/MIcons/ic-categories.svg';
import IcColorCodeFlat from '../assets/svgs/MIcons/ic-code-flat.svg';
import IcColorCheckoutFlat from '../assets/svgs/MIcons/ic-checkout-flat.svg';
import IcColorHostedFlat from '../assets/svgs/MIcons/ic-hosted-flat.svg';
import IcDashboard from '../assets/svgs/MIcons/ic-dashboard.svg';
import IcAngular from '../assets/svgs/MIcons/ic-angular.svg';
import IcGatsby from '../assets/svgs/MIcons/ic-gatsby.svg';
import IcGridsome from '../assets/svgs/MIcons/ic-gridsome.svg';
import IcIonic from '../assets/svgs/MIcons/ic-ionic.svg';
import IcJavascript from '../assets/svgs/MIcons/ic-javascript.svg';
import IcNextJs from '../assets/svgs/MIcons/ic-nextjs.svg';
import IcNuxt from '../assets/svgs/MIcons/ic-nuxt.svg';
import IcReact from '../assets/svgs/MIcons/ic-react.svg';
import IcSvelte from '../assets/svgs/MIcons/ic-svelte.svg';
import IcVue from '../assets/svgs/MIcons/ic-vue.svg';

// Integration icons
import IcAlgolia from '../assets/svgs/integrations/ic-algolia.svg';
import IcAlloy from '../assets/svgs/integrations/ic-alloy.svg';
import IcBraintree from '../assets/svgs/integrations/ic-braintree.svg';
import IcGraphcms from '../assets/svgs/integrations/ic-graphcms.svg';
import IcHasura from '../assets/svgs/integrations/ic-hasura.svg';
import IcKlayvio from '../assets/svgs/integrations/ic-klayvio.svg';
import IcOmise from '../assets/svgs/integrations/ic-omise.svg';
import IcNetlify from '../assets/svgs/integrations/ic-netlify.svg';
import IcPaymill from '../assets/svgs/integrations/ic-paymill.svg';
import IcPaypal from '../assets/svgs/integrations/ic-paypal.svg';
import IcPrismic from '../assets/svgs/integrations/ic-prismic.svg';
import IcRazorpay from '../assets/svgs/integrations/ic-razorpay.svg';
import IcSanity from '../assets/svgs/integrations/ic-sanity.svg';
import IcSendGrid from '../assets/svgs/integrations/ic-sendgrid.svg';
import IcShippo from '../assets/svgs/integrations/ic-shippo.svg';
import IcSquare from '../assets/svgs/integrations/ic-square.svg';
import IcStripe from '../assets/svgs/integrations/ic-stripe.svg';
import IcTaxjar from '../assets/svgs/integrations/ic-taxjar.svg';
import IcTwilio from '../assets/svgs/integrations/ic-twilio.svg';
import IcVercel from '../assets/svgs/integrations/ic-vercel.svg';

// Circle marketing icons imports
import IcLrgStandard from '../assets/svgs/MIcons/ic-lrg-standard.svg';
import IcLrgPlus from '../assets/svgs/MIcons/ic-lrg-plus.svg';
import IcLrgPro from '../assets/svgs/MIcons/ic-lrg-pro.svg';
import IcLrgRise from '../assets/svgs/MIcons/ic-lrg-rise.svg';
import IcLrgGrowth from '../assets/svgs/MIcons/ic-lrg-growth.svg';
import IcLrgEnterprise from '../assets/svgs/MIcons/ic-lrg-enterprise.svg';
import IcLrgBackend from '../assets/svgs/MIcons/ic-lrg-backend.svg';
import IcLrgBusiness from '../assets/svgs/MIcons/ic-lrg-business.svg';
import IcLrgCheckout from '../assets/svgs/MIcons/ic-lrg-checkout.svg';
import IcLrgCode from '../assets/svgs/MIcons/ic-lrg-code.svg';
import IcLrgControl from '../assets/svgs/MIcons/ic-lrg-control.svg';
import IcLrgDesign from '../assets/svgs/MIcons/ic-lrg-design.svg';
import IcLrgDials from '../assets/svgs/MIcons/ic-lrg-dials.svg';
import IcLrgEmbed from '../assets/svgs/MIcons/ic-lrg-embed.svg';
import IcLrgFrontend from '../assets/svgs/MIcons/ic-lrg-frontend.svg';
import IcLrgGuide from '../assets/svgs/MIcons/ic-lrg-guide.svg';
import IcLrgHosted from '../assets/svgs/MIcons/ic-lrg-hosted.svg';
import IcLrgIterate from '../assets/svgs/MIcons/ic-lrg-iterate.svg';
import IcLrgPlatforms from '../assets/svgs/MIcons/ic-lrg-platforms.svg';
import IcLrgScale from '../assets/svgs/MIcons/ic-lrg-scale.svg';
import IcLrgStorefront from '../assets/svgs/MIcons/ic-lrg-storefront.svg';
import IcLrgTesting from '../assets/svgs/MIcons/ic-lrg-testing.svg';
import IcLrgRays from '../assets/svgs/MIcons/ic-lrg-rays.svg';
import IcRaysMono from '../assets/svgs/MIcons/ic-rays-mono.svg';

export const uiIcons = {
  left: IcLeft,
  'double-left': IcDoubleLeft,
  right: IcRight,
  'double-right': IcDoubleRight,
  down: IcDown,
  up: IcUp,
  plus: IcPlus,
  close: IcClose,
  check: IcCheck,
  more: IcMore,
  link: IcLink,
  'right-arrow': IcRightArrow,
  'left-arrow': IcLeftArrow,
  'up-arrow': IcUpArrow,
  'down-arrow': IcDownArrow,
  download: IcDownload,
  upload: IcUpload,
  grip: IcGrip,
  hamburger: IcHamburger,
  minus: IcMinus,
  copy: IcCopy,
  calendar: IcCalendar,
  search: IcSearch,
  refresh: IcRefresh,
  'close-square': IcCloseSquare,
  'check-square': IcCheckSquare,
  'exclamation-square': IcExclamationSquare,
  exclamation: IcExclamation,
  eye: IcEye,
  'question-mark-square': IcQuestionMarkSquare,
  'info-square': IcInfoSquare,
  info: IcInfo,
  delete: IcDelete,
  'thumbs-up': IcThumbsUp,
  'thumbs-down': IcThumbsDown,
  chec: ChecLogo,
  facebook: IcFacebook,
  twitter: IcTwitter,
  github: IcGithub,
  slack: IcSlack,
  'slack-color': IcSlackColor,
  youtube: IcYouTube,
  image: IcImage,
  trash: IcTrash,
  drag: IcDrag,
  bold: IcBold,
  italic: IcItalic,
  'bullet-list': IcBulletList,
  quote: IcQuote,
};

export const navIcons = {
  home: IcHome,
  orders: IcOrders,
  products: IcProducts,
  discounts: IcDiscounts,
  developers: IcDevelopers,
  logs: IcLogs,
  integrations: IcIntegrations,
  settings: IcSettings,
  categories: IcCategories,
  spaces: IcSpaces,
  star: IcStar,
  rays: IcRays,
  customers: IcCustomers,
  account: IcAccount,
};

export const mIcons = {
  standard: IcStandard,
  plusplan: IcPlusPlan,
  pro: IcPro,
  rise: IcRise,
  growth: IcGrowth,
  enterprise: IcEnterprise,
  standardcircle: IcLrgStandard,
  pluscircle: IcLrgPlus,
  procircle: IcLrgPro,
  risecircle: IcLrgRise,
  growthcircle: IcLrgGrowth,
  enterprisecircle: IcLrgEnterprise,
  'code-gray': IcCodeGray,
  start: IcColorStart,
  cart: IcColorCart,
  checkout: IcColorCheckout,
  orders: IcColorOrders,
  products: IcColorProducts,
  categories: IcColorCategories,
  controls: IcControls,
  dashboard: IcDashboard,
  backend: IcLrgBackend,
  business: IcLrgBusiness,
  'checkout-lg': IcLrgCheckout,
  code: IcLrgCode,
  control: IcLrgControl,
  design: IcLrgDesign,
  dials: IcLrgDials,
  embed: IcLrgEmbed,
  frontend: IcLrgFrontend,
  guide: IcLrgGuide,
  hosted: IcLrgHosted,
  iterate: IcLrgIterate,
  platforms: IcLrgPlatforms,
  scale: IcLrgScale,
  storefront: IcLrgStorefront,
  testing: IcLrgTesting,
  rays: IcLrgRays,
  'rays-mono': IcRaysMono,
  'code-flat': IcColorCodeFlat,
  'checkout-flat': IcColorCheckoutFlat,
  'hosted-flat': IcColorHostedFlat,
  // Framework logos that are used in the marketing site
  angular: IcAngular,
  gatsby: IcGatsby,
  gridsome: IcGridsome,
  ionic: IcIonic,
  javascript: IcJavascript,
  nextjs: IcNextJs,
  nuxt: IcNuxt,
  react: IcReact,
  svelte: IcSvelte,
  vue: IcVue,
  // Integration logos used in docs index
  algolia: IcAlgolia,
  alloy: IcAlloy,
  graphcms: IcGraphcms,
  sanity: IcSanity,
  braintree: IcBraintree,
  hasura: IcHasura,
  klayvio: IcKlayvio,
  omise: IcOmise,
  netlify: IcNetlify,
  paymill: IcPaymill,
  paypal: IcPaypal,
  prismic: IcPrismic,
  razorpay: IcRazorpay,
  sendgrid: IcSendGrid,
  shippo: IcShippo,
  square: IcSquare,
  stripe: IcStripe,
  taxjar: IcTaxjar,
  twilio: IcTwilio,
  vercel: IcVercel,
};
